import http, { HttpBodyUnpacking } from '@/lib/request.js'

import * as stamp_model from '@/model/stamp.js'




type THeaderType = 'X-Access-URI' | 'X-Oss-Process' | 'Access-Control-Max-Age'

type THydratedDocumentType = Omit<stamp_model.THydratedDocumentType, 'symbol'>


export function create
(cypher: string, path: string): HttpBodyUnpacking<THydratedDocumentType, THeaderType>
{
	return http.post('/stamp', { cypher, path })


}


export function query
(value: string): HttpBodyUnpacking<THydratedDocumentType, THeaderType>
{
	return http.options(`/stamp/${value}`)


}


export function retrieve
(id: string): HttpBodyUnpacking<THydratedDocumentType, THeaderType>
{
	return http.get(`/stamp/${id}`)


}
